import { type FC } from "react";
import Modal from "~/common/components/Modal";
import ResetPasswordForm from "~/features/auth/login/components/ResetPasswordForm";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import { useResetPasswordLogic } from "~/features/auth/login/hooks/useResetPasswordLogic";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";

const ExpiredPasswordChangePage: FC = () => {
  const { t } = useTranslation();
  const { isResetPopupOpen, openResetPopup, closeResetPopup, onResetSuccess } = useResetPasswordLogic();

  return (
    <>
      <PageTitle title={t("forgottenPwd.expired.title")} />

      <p className={"mb-30"}>{t("forgottenPwd.expired.subtext")} </p>

      <Button onClick={openResetPopup} data-test-id={"reset-pw-btn"}>
        {t("forgottenPwd.expired.buttontext")}
      </Button>

      {isResetPopupOpen && (
        <Modal onClose={closeResetPopup} title={t("popup.forgottenPassword.title")}>
          <ResetPasswordForm onSuccess={onResetSuccess} />
        </Modal>
      )}
    </>
  );
};

export function createExporedPasswordChangePage() {
  return <ExpiredPasswordChangePage />;
}
